if (!customElements.get('smallsmore-mcase-details')) {
  customElements.define('smallsmore-mcase-details', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const parts = JSON.parse(this.querySelector('[data-mcase-detail-parts]').textContent);
      const assembly = this.querySelector('.mc-assembly');
      assembly.addEventListener('click', (event) => {
        const button = event.target.closest('[data-part]');
        const part = button && parts[button.dataset.part];
        if (!part) return;
        assembly.querySelectorAll('[data-part]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        const image = assembly.querySelector('.mc-part-photo');
        image.src = part.src;
        image.alt = part.alt;
        image.width = part.width;
        image.height = part.height;
        assembly.querySelector('.mc-part-description').textContent = part.description;
      }, { signal });

      const track = this.querySelector('.mc-scenes-track');
      const cards = Array.from(track.querySelectorAll('figure'));
      const previous = this.querySelector('[data-gallery-step="-1"]');
      const next = this.querySelector('[data-gallery-step="1"]');
      const status = this.querySelector('.mc-scenes-status');
      const stride = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
      const update = () => {
        const step = stride();
        if (!step || !track.clientWidth) return;
        const first = Math.max(0, Math.floor((track.scrollLeft + 2) / step));
        const last = Math.min(cards.length - 1, Math.ceil((track.scrollLeft + track.clientWidth - 2) / step) - 1);
        status.textContent = `${first + 1}–${last + 1} / ${cards.length}`;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      this.querySelectorAll('[data-gallery-step]').forEach((button) => {
        button.addEventListener('click', () => {
          track.scrollBy({
            left: Number(button.dataset.galleryStep) * stride(),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }, { signal });
      });
      track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(update, 120);
      }, { passive: true, signal });
      let drag = null;
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x: event.clientX, left: track.scrollLeft };
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      }, { signal });
      track.addEventListener('pointermove', (event) => {
        if (drag) track.scrollLeft = drag.left + drag.x - event.clientX;
      }, { signal });
      const finish = () => {
        drag = null;
        track.classList.remove('is-dragging');
        update();
      };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((type) => {
        track.addEventListener(type, finish, { signal });
      });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      clearTimeout(this.scrollTimer);
    }
  });
}
